/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

 function menu_mobile() {
   $(window).resize(function() {
     // Show dropdown category list on mobile
     if($(window).width() <= 991) {
       $(".category_list").addClass("dropdown-menu");
       $('.categories_list .category-title').hide();
     } else {
       $(".category_list").removeClass("dropdown-menu");
       $('.categories_list .category-title').show();
     }
     if($(window).width() <= 479) {
       if($(".nav-links .prev").text() !== "<") {
         $(".nav-links .prev").data('label',$(".nav-links .prev").text());
         $(".nav-links .next").data('label',$(".nav-links .next").text());
         $(".nav-links .prev").html("<");
         $(".nav-links .next").html(">");
       }
     } else {
       $(".nav-links .prev").html($(".nav-links .prev").data('label'));
       $(".nav-links .next").html($(".nav-links .next").data('label'));
     }
   });
   $(window).resize();
 }

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {

      }
    },
    'tax_products_categories': {
      finalize: function() {
        menu_mobile();
      }
    },
    'search_results': {
      finalize: function() {
        menu_mobile();
      }
    },
    'search_no_results': {
      finalize: function() {
        menu_mobile();
      }
    },
    // Contact page
    'page_template_template_contact': {
      finalize: function() {
        $(".wpcf7-submit").on("click",function(event) {
          $( document ).ajaxComplete(function(e) {
            $("#modal-message .modal-body").html($(".wpcf7-response-output").html());
            $('#modal-message').modal('show');
          });
        });
      }
    },
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
